var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21513_23441)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.300781,
    y: 0.00390625,
    width: 66.2567,
    height: 65.4679,
    rx: 10.254,
    fill: "#898989"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8331 27.5239C14.588 27.2699 13.4974 27.049 13.2206 25.415C12.9439 23.7797 12.8524 21.4195 12.9756 20.6006C13.0924 19.8198 15.8221 17.3555 33.2222 17.3555C50.6224 17.3555 53.3521 19.8198 53.4689 20.6006C53.5908 21.4195 53.6212 23.7493 53.2226 25.415C52.8239 27.0808 51.8565 27.2699 51.6102 27.5239C50.498 28.6754 39.1336 29.0093 33.2222 28.7935C27.3109 29.0093 15.9465 28.6754 14.8331 27.5239Z",
    fill: "url(#paint0_radial_21513_23441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8536 30.5323C13.7774 30.0752 13.6962 29.5039 13.8447 28.4755C13.9933 27.4484 14.2383 26.6244 14.8261 26.9609C15.6565 26.1978 15.2642 27.3671 16.7014 29.4722C18.1386 31.5785 16.6912 31.2839 15.946 31.6051C15.0826 31.9733 14.8122 32.033 14.3843 31.6813C13.9831 31.3499 13.9349 31.0148 13.8536 30.5323ZM52.6202 30.5323C52.6964 30.0752 52.7777 29.5039 52.6291 28.4755C52.4806 27.4484 52.2355 26.6244 51.6477 26.9609C50.8174 26.1978 51.2097 27.3671 49.7725 29.4722C48.3352 31.5785 49.7826 31.2839 50.5279 31.6051C51.3912 31.9733 51.6617 32.033 52.0895 31.6813C52.4907 31.3499 52.539 31.0148 52.6202 30.5323Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5614 30.6363C15.4472 30.1855 15.3799 29.6206 15.4624 28.5871C15.5437 27.5523 15.6313 25.898 16.6203 25.8752C17.4824 25.8561 17.2691 27.3924 18.9247 29.406C20.579 31.4196 18.4651 31.2673 17.7084 31.6316C16.8323 32.0531 16.6698 32.3248 16.1975 31.9998C15.7544 31.6938 15.6795 31.1124 15.5614 30.6363ZM50.9102 30.6363C51.0245 30.1855 51.0918 29.6206 51.0092 28.5871C50.928 27.5523 50.8404 25.898 49.8514 25.8752C48.9893 25.8561 49.2026 27.3924 47.5483 29.406C45.8927 31.4196 48.0053 31.2673 48.7633 31.6316C49.6393 32.0531 49.8018 32.3248 50.2741 31.9998C50.7185 31.6938 50.7921 31.1124 50.9102 30.6363Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0241 30.7857C17.8857 30.2651 17.8019 29.6151 17.906 28.4204C18.0088 27.2269 18.2132 25.2742 19.4333 25.2463C20.496 25.2222 21.805 27.3247 21.9091 29.0767C22.0132 30.8301 21.9218 30.6663 21.1981 31.3836L21.1778 31.404C20.3919 32.181 19.5222 33.0418 18.9458 32.671C18.3999 32.3181 18.1701 31.3354 18.0241 30.7857ZM48.4455 30.7857C48.5826 30.2651 48.6664 29.6151 48.5623 28.4204C48.4594 27.2269 48.255 25.2742 47.0349 25.2463C45.9722 25.2222 44.6645 27.3247 44.5591 29.0767C44.455 30.8301 44.5464 30.6663 45.2701 31.3836L45.2917 31.404C46.0763 32.181 46.946 33.0418 47.5224 32.671C48.0684 32.3181 48.2994 31.3354 48.4455 30.7857Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1953 29.9685C21.1953 29.0582 21.2486 28.7205 21.4619 27.6451C21.6778 26.5672 22.3316 25.1211 23.5936 25.1935C25.1718 25.2824 25.7139 27.4128 25.7609 28.2596C25.8205 29.3439 25.832 29.8911 25.7609 31.1049C25.6898 32.3199 25.1388 32.6766 23.2724 32.57C21.4061 32.4646 21.1953 30.8789 21.1953 29.9685ZM45.2749 29.9685C45.2749 29.0582 45.2229 28.7205 45.0083 27.6451C44.7925 26.5672 44.1386 25.1211 42.8766 25.1935C41.2998 25.2824 40.7564 27.4128 40.7094 28.2596C40.6442 29.2069 40.6442 30.1576 40.7094 31.1049C40.7805 32.3199 41.3315 32.6766 43.1978 32.57C45.0642 32.4646 45.2749 30.8789 45.2749 29.9685ZM25.9577 31.3067C25.9272 30.4332 25.9386 28.7396 26.1735 27.5385C26.4147 26.3171 27.4152 24.5727 29.4618 24.5168C31.5072 24.4609 32.5851 26.4161 32.9469 27.8356C33.2262 28.9313 33.1602 29.4582 33.1602 30.7164C33.1602 31.9733 33.4573 32.7503 29.849 32.848C26.2421 32.9458 25.9894 32.1802 25.9577 31.3067Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5089 31.3067C40.5406 30.4332 40.5292 28.7396 40.293 27.5385C40.0543 26.3171 39.0526 24.5727 37.006 24.5168C34.9606 24.4609 33.8827 26.4161 33.5209 27.8356C33.2416 28.9313 33.3076 29.4582 33.3076 30.7164C33.3076 31.9733 33.0105 32.7503 36.6188 32.848C40.2257 32.9458 40.4784 32.1802 40.5101 31.3067H40.5089Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21513_23441",
    x: -6.00938,
    y: -6.30625,
    width: 78.8781,
    height: 78.0891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21513_23441",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2235 14.8162) scale(33.0583 17.1026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FA9FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC7475"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpper);
export default __webpack_public_path__ + "static/media/Upper.cc90fc09eccbdcadad498adbae8ff081.svg";
export { ForwardRef as ReactComponent };